import { render, staticRenderFns } from "./Pois.vue?vue&type=template&id=5970c9e6&scoped=true&"
import script from "./Pois.vue?vue&type=script&lang=js&"
export * from "./Pois.vue?vue&type=script&lang=js&"
import style0 from "./Pois.vue?vue&type=style&index=0&id=5970c9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5970c9e6",
  null
  
)

export default component.exports